const en = {
    nav: {
        about: 'About us',
        services: 'Services',
        contact: 'Contact',
        language: 'Language',
    },
    slides: {
        s1Subtitle: 'Providing magnetic compass services and certificates since 1939.',
        readAbout: 'Read about us',
        s2Before: 'We are the first company to introduce a ',
        s2Highlight: 'remote adjustment service',
        s2After: ' for magnetic compasses.',
        s2Text: 'Have your magnetic compass adjusted remotely and get all the necessary certificates to present to any local or international authority.',
        learnMore: 'Learn more',
        getQuote: 'Get a quote',
        imgAlt: 'Ship bridge with navigation equipment',
    },
    about: {
        title: 'About us',
        imgAlt: "Magnetic compass on a ship's deck",
        since: 'Since',
        eyebrow: 'Who we are',
        heading: 'Repairing and calibrating magnetic compasses for over 85 years.',
        text: 'The only authorized laboratory in Argentina issuing certificates with all international and legal validations, accepted worldwide by any classification society or Coast Guard authority.',
        checks: [
            'Authorized by PNA (Argentina, IMO member state)',
            'First fully remote compass calibration service',
            'Magnetic compass calibration and certificates in less than 24h',
        ],
        counters: ['Issued certificates', 'Repaired compasses', 'Completed services'],
        partner: 'Official service and distributor',
    },
    services: {
        title: 'Services',
        flagship: 'Our flagship service',
        remoteTitle: 'Remote Calibration',
        remoteSubtitle: 'Calibrate your magnetic compass while navigating anywhere in the world. No technician on board, no docking.',
        steps: [
            { title: 'Share the data.', text: 'The captain uploads the compass information to our online platform.' },
            { title: 'Get instructions.', text: 'Easy, detailed steps to adjust the deviations.' },
            { title: 'Adjust with support.', text: 'A technician is available 24/7 for any inquiry.' },
            { title: 'Receive certificates.', text: 'New deviation card and certificates by email.' },
        ],
        imgAlt: 'Online platform',
        figcaption: 'All compass information in one place, on our online platform.',
        advShipTitle: 'Advantages for the ship',
        advShip: [
            'Adjust while navigating, without docking or delaying the voyage',
            'A technician available 24/7',
        ],
        advOwnersTitle: 'Advantages for owners and managers',
        advOwners: [
            'No embarkation or disembarkation costs for the technician',
            'Fixed budget, no extra cost by day or hour; cheaper in volume',
        ],
        howItWorks: 'How it works',
        onboardTitle: 'On-board calibration',
        onboardText: 'A technician on board manually calibrates the magnetic compass and issues the certificates, digitally signed by technician and captain.',
        onboardSteps: [
            'The technician will ask the captain to perform certain maneuvers in order to check and adjust the magnetic compass as necessary.',
            'Once all deviations have been adjusted, the technician will issue the certificates on board with all legal and international validations. Both will be digitally signed by the technician and the captain.',
        ],
        repairTitle: 'Magnetic compass repair',
        repairText: 'Ship or bring your compass to our laboratory. Repaired in less than 24 hours, with an overhaul certificate and a 1-year warranty.',
        repairSteps: [
            'The magnetic compass is inspected in order to identify the problem.',
            'One of our technicians will have it repaired in less than 24 hours.',
            'Once repaired, our technician will issue the compass overhaul certificate, including a one-year warranty.',
        ],
    },
    contact: {
        title: 'Contact',
        intro: 'Need a quote or have a question? Our technicians will get back to you.',
        getInTouch: 'Get in touch',
        getInTouchText: 'Call, write or message us. We answer from anywhere in the world.',
        international: 'US / International',
        technical: 'Technical department',
        email: 'Email',
        laboratory: 'Laboratory',
        openMaps: 'Open in Maps',
        whatsapp: 'Chat on WhatsApp',
        showEmail: 'Show email',
        form: {
            title: 'Send us a message',
            required: 'All fields are required.',
            name: 'Full name',
            email: 'Email',
            phone: 'Cellphone',
            enterprise: 'Enterprise',
            subject: 'Subject',
            message: 'Message',
            recaptcha: 'Protected by reCAPTCHA.',
            send: 'Send message',
            sending: 'Sending... Please wait.',
            sendError: 'Something went wrong! Please try again later or send us an email directly.',
        },
        errors: {
            name: 'Name is required',
            email: 'Email is required',
            emailInvalid: 'Email is not valid',
            phone: 'Cellphone is required',
            enterprise: 'Enterprise is required',
            subject: 'Subject is required',
            message: 'Message is required',
        },
    },
    footer: {
        slogan: 'Providing magnetic compass services and certificates since 1939',
        terms: 'Terms & Conditions',
        policy: 'Policy',
    },
}

export default en
